module.exports = __webpack_public_path__ + "static/weight-balance-55cd5cc9d04a2aac3498466b7738ecb8.webm";